
import { useState, useEffect, useMemo } from "react";
import { Box, Grid, Typography, Pagination } from "@mui/material";
import { logger } from "../../../utils/logger";
import DownloadButton from "./PDFDownloader";
import TopLabel from "./utils/topLabelLayout";
import BottomLabel from "./utils/bottomLabelLayout";

const ITEMS_PER_PAGE = 12;

const NpfUafPage = ({ data = [], labelposition, type, username, role }) => {
  const [page, setPage] = useState(1);

  // ✅ Keep backend order exactly
  const filteredData = useMemo(() => {
    if (!data || data.length === 0) return [];
    return data;
  }, [data]);

  const totalPages = useMemo(
    () => Math.ceil(filteredData.length / ITEMS_PER_PAGE),
    [filteredData]
  );

  // ✅ Simple pagination — NO reordering
  const paginatedData = useMemo(
    () =>
      filteredData.slice(
        (page - 1) * ITEMS_PER_PAGE,
        page * ITEMS_PER_PAGE
      ),
    [filteredData, page]
  );

  useEffect(() => {
    setPage(1);
  }, [data, type]);

  useEffect(() => {
    if (!data || !data.length) return;

    logger.info("Data filtered and displayed", {
      username,
      role,
      filterType: type,
      totalRecords: filteredData.length,
      displayedRecords: paginatedData.length,
      currentPage: page,
      totalPages,
    });
  }, [
    filteredData.length,
    paginatedData.length,
    page,
    totalPages,
    username,
    role,
    type,
    data,
  ]);

  return (
    <Box sx={{ padding: 1 }}>
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <DownloadButton
          data={filteredData}
          type={type}
          labelposition={labelposition}
          username={username}
          role={role}
        />
      </Box>

      {paginatedData.length > 0 ? (
        <Grid container spacing={2}>
          {paginatedData.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              {labelposition === "bottom"
                ? BottomLabel(item)
                : TopLabel(item)}
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography>No data found</Typography>
      )}

      {totalPages > 1 && (
        <Box display="flex" justifyContent="center" mt={6} mb={2}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(e, value) => setPage(value)}
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
};

export default NpfUafPage;
